import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

const Spinner = ({ className }) => (
  <FontAwesomeIcon className={classNames("fa-spin", className)} icon="spinner" />
);

Spinner.propTypes = {
  className: PropTypes.string,
};

export default Spinner;
